import { c as _c } from "react/compiler-runtime";
import { chakra, Separator, HStack, IconButton } from '@chakra-ui/react';
import { Tooltip } from '@src/components/chakra-ui/tooltip';
import { injectBlock, injectMark, isBlockActive, toggleBlock } from '@src/components/sco/RichMarkdownInput/utilities/blocks';
import { isMarkActive, toggleMark } from '@src/components/sco/RichMarkdownInput/utilities/marks';
import { AnimatePresence, motion } from 'framer-motion';
import React, { ReactElement, ReactNode, useMemo, useState } from 'react';
import { GoMention } from 'react-icons/go';
import { MdAddCircle, MdEmojiEmotions, MdFormatBold, MdFormatItalic, MdFormatListBulleted, MdFormatListNumbered, MdFormatQuote, MdFormatStrikethrough, MdFormatUnderlined, MdGif, MdImage, MdLink, MdUploadFile } from 'react-icons/md';
import { useFocused, useSelected, useSlate } from 'slate-react';
const IS_DEV = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production';
export const Toolbar = props => {
  const $ = _c(25);
  const [showInjections, setShowInjections] = useState(props.showInjections);
  let t0;
  if ($[0] !== props.placement) {
    t0 = props.placement === "top" ? {
      borderBottom: "1px solid",
      borderColor: "colorPalette.border/50"
    } : {
      borderTop: "1px solid",
      borderColor: "colorPalette.border/50"
    };
    $[0] = props.placement;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const border = t0;
  let t1;
  if ($[2] !== props.showInjections || $[3] !== showInjections) {
    t1 = IS_DEV && <HStack backgroundColor={showInjections ? "whiteAlpha.50" : "transparent"} borderRadius="8px" gap="0" marginRight={showInjections ? "6px" : 0}>{props.showInjections && <React.Fragment><ToolbarButton icon={<MdAddCircle />} title="Insert" onClick={() => setShowInjections(_temp)} /></React.Fragment>}<AnimatePresence>{showInjections && <motion.div animate={{
          opacity: 1,
          width: "inherit"
        }} exit={{
          opacity: 0,
          width: 0
        }} initial={props.showInjections ? {} : {
          opacity: 0,
          width: 0
        }} style={{
          overflow: "hidden"
        }} transition={{
          duration: 0.3
        }}><HStack bgColor="rgba(255,255,255,.05" borderRadius="2px" gap={0} padding={0} width="100%"><Separator height="1em" marginX="2px" orientation="vertical" /><ToolbarButton icon={<GoMention />} injectBlock="mention" title="Mention" /><ToolbarButton icon={<MdEmojiEmotions />} injectBlock="emoji" title="Emoji" /><ToolbarButton icon={<MdImage />} injectBlock="image" title="Image" /><ToolbarButton icon={<MdGif />} injectBlock="giphy" title="Gif" /><ToolbarButton icon={<MdUploadFile />} injectBlock="file" title="File" /></HStack></motion.div>}</AnimatePresence></HStack>;
    $[2] = props.showInjections;
    $[3] = showInjections;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToolbarButton hotKey={"\u2318B"} icon={<MdFormatBold />} title="Bold" toggleMark="bold" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ToolbarButton hotKey={"\u2318I"} icon={<MdFormatItalic />} title="Italic" toggleMark="italic" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ToolbarButton hotKey={"\u2318U"} icon={<MdFormatUnderlined />} title="Underline" toggleMark="underline" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ToolbarButton icon={<MdFormatStrikethrough />} title="Strikethrough" toggleMark="strikethrough" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ToolbarButton icon={<MdLink />} injectBlock="link" title="Link" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props) {
    t7 = props.enableFileAttachments && <ToolbarButton icon={<MdUploadFile />} title="Attach file" onClick={() => {
      if (!props.fileAttachmentsDisabled) {
        props.onAttachFileClick?.();
      }
    }} />;
    $[10] = props;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ToolbarButton icon={<MdFormatQuote />} title="Quote" toggleBlock="block_quote" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ToolbarButton icon={<MdFormatListNumbered />} title="Numbered List" toggleBlock="ol_list" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ToolbarButton icon={<MdFormatListBulleted />} title="Bullet List" toggleBlock="ul_list" />;
    t11 = <Separator orientation="vertical" />;
    $[14] = t10;
    $[15] = t11;
  } else {
    t10 = $[14];
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t1 || $[17] !== t7) {
    t12 = <HStack gap="0" overflowX="auto">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</HStack>;
    $[16] = t1;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== props.additionalButtons) {
    t13 = props.additionalButtons && <HStack align="center" flexGrow={0} justify="flex-end" justifySelf="end" width="auto">{props.additionalButtons}</HStack>;
    $[19] = props.additionalButtons;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== border || $[22] !== t12 || $[23] !== t13) {
    t14 = <HStack align="center" {...border} justify="space-between" padding="4px" width="full">{t12}{t13}</HStack>;
    $[21] = border;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
export const ToolbarButton = props => {
  const $ = _c(36);
  const editor = useSlate();
  const focused = useFocused();
  const selected = useSelected();
  let isActive = undefined;
  let onMouseDown = _temp2;
  const toggle = props.toggleMark || props.toggleBlock;
  const inject = props.injectMark || props.injectBlock;
  const label = toggle || inject;
  if (toggle) {
    if (props.toggleMark) {
      let t0;
      if ($[0] !== editor || $[1] !== props.toggleMark) {
        t0 = isMarkActive(editor, props.toggleMark);
        $[0] = editor;
        $[1] = props.toggleMark;
        $[2] = t0;
      } else {
        t0 = $[2];
      }
      isActive = t0;
      let t1;
      if ($[3] !== editor || $[4] !== props.toggleMark) {
        t1 = event_0 => {
          event_0.preventDefault();
          toggleMark(editor, props.toggleMark);
        };
        $[3] = editor;
        $[4] = props.toggleMark;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      onMouseDown = t1;
    }
    if (props.toggleBlock) {
      let t0;
      if ($[6] !== editor || $[7] !== props.toggleBlock) {
        t0 = isBlockActive(editor, props.toggleBlock);
        $[6] = editor;
        $[7] = props.toggleBlock;
        $[8] = t0;
      } else {
        t0 = $[8];
      }
      isActive = t0;
      let t1;
      if ($[9] !== editor || $[10] !== props.toggleBlock) {
        t1 = event_1 => {
          event_1.preventDefault();
          toggleBlock(editor, props.toggleBlock);
        };
        $[9] = editor;
        $[10] = props.toggleBlock;
        $[11] = t1;
      } else {
        t1 = $[11];
      }
      onMouseDown = t1;
    }
  }
  if (inject) {
    if (props.injectMark) {
      let t0;
      if ($[12] !== editor || $[13] !== props.injectMark) {
        t0 = event_2 => {
          event_2.preventDefault();
          injectMark(editor, props.injectMark);
        };
        $[12] = editor;
        $[13] = props.injectMark;
        $[14] = t0;
      } else {
        t0 = $[14];
      }
      onMouseDown = t0;
    }
    if (props.injectBlock) {
      let t0;
      if ($[15] !== editor || $[16] !== props.injectBlock) {
        t0 = event_3 => {
          event_3.preventDefault();
          injectBlock(editor, props.injectBlock);
        };
        $[15] = editor;
        $[16] = props.injectBlock;
        $[17] = t0;
      } else {
        t0 = $[17];
      }
      onMouseDown = t0;
    }
  }
  if (props.onClick) {
    let t0;
    if ($[18] !== props) {
      t0 = event_4 => {
        event_4.preventDefault();
        props.onClick(event_4);
      };
      $[18] = props;
      $[19] = t0;
    } else {
      t0 = $[19];
    }
    onMouseDown = t0;
  }
  let t0;
  if ($[20] !== props.hotKey || $[21] !== props.title) {
    t0 = props.title ? <HStack gap="4px"><span>{props.title}</span>{props.hotKey && <chakra.code bgColor="whiteAlpha.400" borderRadius="4px" display="inline-block" fontFamily="monospace" fontSize="12px" letterSpacing="1px" lineHeight={1} padding="2px 4px" verticalAlign="baseline">{props.hotKey}</chakra.code>}</HStack> : null;
    $[20] = props.hotKey;
    $[21] = props.title;
    $[22] = t0;
  } else {
    t0 = $[22];
  }
  let t1;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placement: "top"
    };
    $[23] = t1;
  } else {
    t1 = $[23];
  }
  let t2;
  if ($[24] !== isActive) {
    t2 = isActive ? {
      bg: "colorPalette.emphasized"
    } : undefined;
    $[24] = isActive;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  const t3 = isActive ? "colorPalette.emphasized" : undefined;
  const t4 = isActive || undefined;
  let t5;
  if ($[26] !== label || $[27] !== onMouseDown || $[28] !== props.icon || $[29] !== t2 || $[30] !== t3 || $[31] !== t4) {
    t5 = <IconButton _hover={t2} aria-label={label} bg={t3} data-active={t4} size="sm" title={label} variant="ghost" onMouseDown={onMouseDown}>{props.icon}</IconButton>;
    $[26] = label;
    $[27] = onMouseDown;
    $[28] = props.icon;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  let t6;
  if ($[33] !== t0 || $[34] !== t5) {
    t6 = <Tooltip borderRadius="6px" fontSize="11px" fontWeight="bold" letterSpacing="0.05em" textTransform="uppercase" content={t0} positioning={t1}>{t5}</Tooltip>;
    $[33] = t0;
    $[34] = t5;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  return t6;
};
function _temp(x) {
  return !x;
}
function _temp2(event) {
  alert("Not implemented yet!");
}